export const getArchiveFileUrl = (fileId: string, downloadable?: boolean) => {
  const isDownloadable = downloadable ? '?download=true' : '';
  return `${process.env.REACT_APP_API_URL}/portal-api/v1/archive/files/${fileId}/file${isDownloadable}`;
};
